import { SiteHeader } from "@/components/site/SiteHeader";
import { HeroSection } from "@/components/site/HeroSection";
import { MarqueeStrip } from "@/components/site/MarqueeStrip";
import { CategoryBoxes } from "@/components/site/CategoryBoxes";
import { ProductGrid } from "@/components/site/ProductGrid";
import { BrandFeatures } from "@/components/site/BrandFeatures";
import { AboutSection } from "@/components/site/AboutSection";
import { TestimonialsSection } from "@/components/site/TestimonialsSection";
import { NewsletterSection } from "@/components/site/NewsletterSection";
import { SocialStrip } from "@/components/site/SocialStrip";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-body text-zinc-900" data-testid="home-page">
      <SiteHeader />
      <main>
        <HeroSection />
        <MarqueeStrip />
        <CategoryBoxes />
        <ProductGrid />
        <BrandFeatures />
        <AboutSection />
        <TestimonialsSection />
        <NewsletterSection />
        <SocialStrip />
      </main>
      <SiteFooter />
    </div>
  );
}
